import type { TableFilterOption } from '../types';

export class TableFilterOptionsHelper {
  static mergeOptions(
    existing: readonly TableFilterOption[],
    incoming: readonly TableFilterOption[]
  ): TableFilterOption[] {
    const optionsByValue = new Map<string, TableFilterOption>();
    [...existing, ...incoming].forEach((option) => {
      optionsByValue.set(String(option.value), option);
    });
    return Array.from(optionsByValue.values());
  }
}
